import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify from 'vuetify';
import colors from 'vuetify/es5/util/colors';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    dark: true,
    themes: {
      light: {
        primary: '#3c3cf0',
        secondary: '#141450',
        accent: '#3cf0dc',
        error: colors.red.base,
        warning: colors.deepOrange.base,
        info: colors.lightBlue.base,
        success: colors.teal.accent4,
      },
      dark: {
        primary: '#3c3cf0',
        secondary: '#141450',
        accent: '#3cf0dc',
        error: colors.red.base,
        warning: colors.deepOrange.base,
        info: colors.lightBlue.base,
        success: colors.teal.accent4,
      }
    }
  }
});
